/**
 * Lyra config service to get lyra config
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */

/**
 * Return lyra config. Config added in @/config
 * For lyra keys contact developers@huumun.com
 * @returns - object with lyra configured brand key & project key
 */
module.exports.lyraConfig = function () {
	/*
		TODO: Investigate and check for script
		try {
			const _lyraConfig = require('@/config/lyra.config');
			const lyraConfig = _lyraConfig && _lyraConfig.default ? _lyraConfig.default : _lyraConfig;
			return lyraConfig;
		} catch (err) {
			console.warn(err);
			return { brandKey: '', projectKey: '' };
		}
	*/

	/**
	 * TODO: Fail safe to be removed
	 */
	return {
		brandKey: '05a203d85ee01909eaf728dc16f0f6cb',
		projectKey: 'd4cfeeabbd82c8682011d080f3903978',
	};
} 